import comp from "./ProjectGroup.js";
export default comp;
